<div class="newsletter-container">
  <div class="newsletter-content">
    <div class="text-container">
      <h2>{{ 'home.subscribe.title' | translate }}</h2>
    </div>

    <form class="form-social-row" (ngSubmit)="onSubmit(emailForm)" #emailForm="ngForm">
      <div class="input-group">
        <input
          type="email"
          [placeholder]="'home.subscribe.placeholder' | translate"
          class="email-input"
          name="email"
          [(ngModel)]="email"
          #emailCtrl="ngModel"
          required
          email
        />
        <button class="subscribe-btn" type="submit">
          {{ 'home.subscribe.button' | translate }}
        </button>
      </div>

      <div class="social__img__container">
        <img 
          width="40" 
          height="40" 
          src="assets/img/share_facebook.svg" 
          alt="social_facebook" />
        <img 
          width="40" 
          height="40" 
          src="assets/img/share_twitter.svg" 
          alt="social_twitter" />
        <img 
          width="40" 
          height="40" 
          src="assets/img/share_pinterest.svg" 
          alt="social_pinterest" />
        <img 
          width="40" 
          height="40" 
          src="assets/img/share_instagram.svg" 
          alt="social_instagram" />
      </div>

      <div *ngIf="emailCtrl.invalid && emailForm.submitted" class="error">
        <span *ngIf="emailCtrl.errors?.['required']">
          {{ 'home.subscribe.error_required' | translate }}
        </span>
        <span *ngIf="emailCtrl.errors?.['email']">
          {{ 'home.subscribe.error_format' | translate }}
        </span>
      </div>
    </form>
  </div>
</div>